export function debounce(func, wait, scope) {
  var timeout;
  wait = wait || 300;
  return function() {
    var context = scope || this,
      args = arguments;
    var later = function() {
      timeout = null;
      func.apply(context, args);
    };
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
  };
}

export async function extractErrorMessage(res) {
  const text = await res.text();
  try {
    const json = JSON.parse(text);
    return json.message || text;
  } catch (e) {
    return text;
  }
}